import axios from 'axios'
import { CADASTRAR_COMISSAO_REIMPRESSAO_RECIBO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarComissaoReimpressaoRecibo (comando) {
  const url = `${URL}/pedido/comissao-reimpressao`;
  return dispatch => axios.post(url, comando, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_COMISSAO_REIMPRESSAO_RECIBO,
        payload: response
      })
  );
}
